export default __webpack_public_path__ + "static/media/main_level_test01_jp.ca0be0af.png";